
import debounce from 'lodash/debounce'
import 'components/catalog.tag'
import moment from 'moment'
import 'pages/orders/stock-list-modal.tag'
riot.tag2('orders-list-paid', '  <catalog object="OrderPaid" search="true" sortable="true" cols="{cols}" handlers="{handlers}" reload="true" remove="{permission(remove, &quot;orders-paid&quot;, &quot;0001&quot;)}" dblclick="{permission(orderOpen, &quot;orders&quot;, &quot;1000&quot;)}" before-success="{getAggregation}" store="orders-list-paid" new-filter="true" allselect="true">\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">От даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&gt;=" format="DD.MM.YYYY" value="{parent.startDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">До даты</label>\n            <datetime-picker class="form-control date-picker" data-name="dateOrder" data-sign="&lt;=" format="DD.MM.YYYY" value="{parent.endDate}"></datetime-picker>\n          </div>\n          <div class="form-group">\n            <label class="control-label">Склад</label>\n            <select class="form-control" data-name="isStock">\n              <option value="">Все</option>\n              <option value="1">На складе</option>\n              <option value="0">Нет</option>\n            </select>\n\n          </div>\n\n\n        </div>\n      </div>\n    </yield>\n    <yield to="head">\n      <div class="dropdown" if="{checkPermission(&quot;orders&quot;, &quot;0010&quot;) &amp;&amp; selectedCount &gt; 0}" style="display: inline-block;">\n        <button class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" type="button" aria-expanded="true">Действия&nbsp;<span class="caret"></span></button>\n        <ul class="dropdown-menu">\n          <li onclick="{handlers.sendToStock}"><a href="#"><i class="fa fa-share-square-o"></i> Отправить на склад</a></li>\n          <li onclick="{handlers.addToPart}"><a href="#"><i class="fa fa-plus-square"></i> Добавить в партию</a></li>\n        </ul>\n      </div>\n    </yield>\n    <yield to="body">\n      <datatable-cell style="width:10px;"><span class="fa fa-fw select-row {row.__selected__ ? &quot;fa-check-square-o&quot; : &quot;fa-square-o&quot;}"></span></datatable-cell>\n      <datatable-cell name="id" style="width:100px;"><a class="open-page-item" href="#orders/{row.id}" target="_blank">{row.id}</a></datatable-cell>\n      <datatable-cell class="{bg-danger: (row.isPaid), bg-warning: (row.isPartPaid), bg-success: (row.isSentUser)}" name="status" style="width:180px;">{row.status}</datatable-cell>\n      <datatable-cell name="dateOrder" onclick="{handlers.copyText}" style="width:100px;">{row.dateOrderDisplay}</datatable-cell>\n      <datatable-cell name="timeOrder" onclick="{handlers.copyText}" style="width:100px;">{row.timeOrder}</datatable-cell>\n      <datatable-cell name="datePayee" onclick="{handlers.copyText}" style="width:100px;">{row.datePayeeDisplay}</datatable-cell>\n      <datatable-cell name="amount" onclick="{handlers.copyText}" style="width:100px;"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.amount.toFixed(0)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="personalDiscount" onclick="{handlers.copyText}" style="width:100px;">{row.personalDiscount.toFixed(0)}%</datatable-cell>\n\n      <datatable-cell name="customerEmail" onclick="{handlers.copyText}" style="width:180px;">{row.customerEmail}</datatable-cell>\n      <datatable-cell name="paymentName" onclick="{handlers.copyText}" style="width:180px;">{row.paymentName}</datatable-cell>\n      <datatable-cell name="deliveryName" onclick="{handlers.copyText}" style="width:180px;">{row.deliveryName}</datatable-cell>\n      <datatable-cell name="commentary" onclick="{handlers.copyText}">{row.commentary}</datatable-cell>\n    </yield>\n    <yield to="aggregation"><strong> Сумма:</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? parent.currTotal.nameFront : ⁗⁗}</strong><strong> {(parent.totalAmount || 0)}</strong><strong> {parent.currTotal.nameFront !== null && parent.currTotal.nameFront !== ⁗⁗ ? ⁗⁗ : parent.currTotal.nameFlang !== null && parent.currTotal.nameFlang !== ⁗⁗ ? parent.currTotal.nameFlang : parent.currTotal.titleCurr}</strong><br></yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'OrderPaid';
self.idManager = app.config.idUser;
self.startDate = '';
self.endDate = '';

self.cols = [{ name: '', value: '' }, { name: 'id', value: 'Заказ' }, { name: 'status', value: 'Статус' }, { name: 'dateOrder', value: 'Дата' }, { name: 'timeOrder', value: 'Время' }, { name: 'datePayee', value: 'Дата оплаты' }, { name: 'amount', value: 'Сумма' }, { name: 'personalDiscount', value: 'Скидка' },
//{ name: 'idStock' , value: 'Партия' },
{ name: 'customerEmail', value: 'Email' }, { name: 'paymentName', value: 'Оплата' }, { name: 'deliveryName', value: 'Доставка' }, { name: 'commentary', value: 'Комментарий заказчика' }];

self.orderText = {
    text: {
        Y: 'Оплачен', N: 'Не оплачен', A: 'Предоплата', D: 'Отказ', K: 'Кредит', P: 'Подарок', W: 'В ожидании', C: 'Возврат', T: 'Тест'
    },
    colors: {
        //Y: '#98FB98', N: '#FFC1C1', A: '#FFFF00', K: '#FFAAAA', P: null, W: null, C: null, T: null
        Y: 'bg-success', N: 'bg-danger', A: 'bg-warning', K: 'bg-info', D: 'bg-danger', P: null, W: null, C: null, T: null
    }
};

self.deliveryText = {
    text: {
        Y: 'Доставлен', N: 'Не доставлен', M: 'В работе', P: 'Отправлен'
    },
    colors: {
        //Y: '#98FB98', N: '#FFC1C1', M: null, P: null
        Y: 'bg-success', N: 'bg-danger', M: null, P: null
    }
};

self.handlers = {
    orderText: self.orderText,
    deliveryText: self.deliveryText,
    copyText: function copyText(elem) {
        //copyToClipboard(elem.target)
    },
    sendToStock: function sendToStock(e) {
        var params = self.tags.catalog.getSelectedMode();
        params['toStock'] = true;

        API.request({
            object: 'OrderPaid',
            method: 'Save',
            data: params,
            success: function success(response) {
                self.tags.catalog.reload();
            }
        });
    },
    addToPart: function addToPart(e) {
        self.debuger((0, _extends3.default)({}, self.debugParam, { method: "addToPart" }));
        modals.create('stock-list-modal', {
            type: 'modal-primary',
            size: 'modal-lg',
            submit: function submit() {
                var items = this.tags.catalog.tags.datatable.getSelectedRows();

                var params = self.tags.catalog.getSelectedMode();
                params['toPart'] = { id: items[0].id, name: items[0].name };

                API.request({
                    object: 'OrderPaid',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        self.tags.catalog.reload();
                    }
                });
                this.modalHide();
            }
        });
    }
};

self.orderOpen = function (e) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orderOpen" }));
    riot.route('/orders/' + e.item.row.id + '?back=paid');
};

self.getAggregation = function (response, xhr) {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "getAggregation" }));
    self.totalAmount = parseFloat(response.totalAmount);
    self.currTotal = response.currTotal;
    if (response.counts) observable.trigger('tabs-update', response.counts);
};

self.add = function () {
    return riot.route('/orders/new');
};

observable.on('orders-reload', function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "orders-reload" }));
    self.tags.catalog.reload();
});

self.on('mount', function () {
    self.debuger((0, _extends3.default)({}, self.debugParam, { method: "mount" }));
    self.idManager = app.config.idUser;
    self.update();
});

function copyToClipboard(elem) {
    //self.debuger({ ...self.debugParam, method:"copyToClipboard" })
    var target = {};
    // create hidden text element, if it doesn't already exist
    var targetId = "_hiddenCopyText_";
    var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
    var origSelectionStart, origSelectionEnd;
    if (isInput) {
        // can just use the original source element for the selection and copy
        target.assign(elem);
        origSelectionStart = target.selectionStart;
        origSelectionEnd = target.selectionEnd;
    } else {
        // must use a temporary form element for the selection and copy
        target = document.getElementById(targetId);
        if (!target) {
            var target = document.createElement("textarea");
            target.style.position = "absolute";
            target.style.left = "-9999px";
            target.style.top = "0";
            target.id = targetId;
            document.body.appendChild(target);
        }
        target.textContent = target.textContent.trim();
    }
    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    var succeed;
    try {
        succeed = document.execCommand("copy");
    } catch (e) {
        succeed = false;
    }
    /*
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === "function") {
        currentFocus.focus();
    }
         if (isInput) {
        // restore prior selection
        elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
        // clear temporary content
        target.textContent = "";
    }
    */
    return succeed;
}

self.debugParam = {
    module: "orders-list-paid.tag",
    dClass: "orders-list-paid",
    method: "",
    dComment: "",
    groupLog: "norm",
    dArray: undefined
};
self.debuger = function () {
    var dp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.debugParam;

    /** ДЕБАГЕР
     * 1 Запуск логов
     * 2 Настройки
     * 3 Формирование строки
     * 4 Отступ
     * 5 Очередность и отображение
     *
     * self.debuger({ ...self.debugParam, method:"allParams" })
     *
     * self.debuger({ ...self.debugParam, method:"reload",
     *                groupLog: "reload", dComment:"response", dArray: response })
     */

    // 1
    var startList = {
        norm: true
    };

    if (startList[dp.groupLog] == true && document.domain == "localhost") {

        // 2
        var ind = 30;var ind2 = 12;var sy = " ";var col = " |";
        var gr = true;var com = true;var met = true;var cl = true;var mod = true;

        // 3
        var groupLog = "gr: " + dp.groupLog;
        var comment = "com: " + dp.dComment;
        var method = "met: " + dp.method;
        var clas = "cl: " + dp.dClass;
        var module = "mod: " + dp.module;

        // 4
        var groupLogLen = sy.repeat(ind2 - groupLog.length >= 0 ? ind2 - groupLog.length : 0) + col;
        var commentLen = sy.repeat(ind - comment.length >= 0 ? ind - comment.length : 0) + col;
        var methodLen = sy.repeat(ind - method.length >= 0 ? ind - method.length : 0) + col;
        var clasLen = sy.repeat(ind - clas.length >= 0 ? ind - clas.length : 0) + col;
        var modLen = sy.repeat(ind - module.length >= 0 ? ind - module.length : 0) + col;

        // 5
        var consoleLog = "|";
        if (gr == true) consoleLog += groupLog + groupLogLen;
        if (com == true) consoleLog += comment + commentLen;
        if (met == true) consoleLog += method + methodLen;
        if (cl == true) consoleLog += clas + clasLen;
        if (mod == true) consoleLog += module + modLen;

        console.warn(consoleLog);
        if (dp.dArray != undefined) console.log(dp.dArray);
    }
};
});


// WEBPACK FOOTER //
// ./pages/orders/orders-list-paid.tag